<template>
  <div v-loading="loading">
    <template v-if="meeting">
      <page-heading :heading="meetingHeading">
        <span slot="right">
          <el-tag
            :type="$oneToOneConstants.meetings.statusTypes[meeting.status]"
            style="margin-right: 12px;"
          >
            {{ $oneToOneConstants.meetings.statusesSelectOptions.find(e => e.id===meeting.status).name || meeting.status }}
          </el-tag>

          <el-button
            v-if="$canAndRulesPass(meeting, $permissions.ONE_TO_ONE.MEETING_UPDATE)"
            size="small"
            @click="$refs.editDialog.open(meeting)"
          >
            Редактировать
          </el-button>

          <el-button
            v-if="$canAndRulesPass(meeting, $permissions.ONE_TO_ONE.MEETING_FINISH)"
            size="small"
            type="primary"
            @click="finishMeeting"
            :loading="actionLoading"
          >
            Завершить встречу
          </el-button>

          <el-popconfirm
            v-if="$canAndRulesPass(meeting, $permissions.ONE_TO_ONE.MEETING_CANCEL)"
            confirm-button-text="Да"
            cancel-button-text="Нет"
            icon="el-icon-question"
            title="Отменить встречу?"
            @confirm="cancelMeeting"
          >
            <el-button
              slot="reference"
              size="small"
              type="danger"
              plain
              style="margin-left: 10px;"
            >
              Отменить
            </el-button>
          </el-popconfirm>
        </span>
      </page-heading>


      <el-card class="meeting-info-card" shadow="never">
        <el-row :gutter="24">
          <el-col :span="7">
            <div class="info-label">Инициатор</div>
            <div class="info-value">{{ meeting.initiator ? (meeting.initiator.last_name + ' ' + meeting.initiator.first_name) : '—' }}</div>
          </el-col>
          <el-col :span="6">
            <div class="info-label">Участник</div>
            <div class="info-value">{{ meeting.participant ? (meeting.participant.last_name + ' ' + meeting.participant.first_name) : '—' }}</div>
          </el-col>
          <el-col :span="2">
            <div class="info-label">Дата</div>
            <div class="info-value">{{ formatDate(meeting.date) }}</div>
          </el-col>
          <el-col :span="2">
            <div class="info-label">Время</div>
            <div class="info-value">{{ meeting.time ? meeting.time.slice(0, 5) : '—' }}</div>
          </el-col>
          <el-col :span="3">
            <div class="info-label">Длительность</div>
            <div class="info-value">{{ meeting.planned_duration ? meeting.planned_duration + ' мин.' : '—' }}</div>
          </el-col>
          <el-col :span="2">
            <div class="info-label">Тип</div>
            <div class="info-value">{{ $oneToOneConstants.meetings.typeSelectOptions.find(e=>e.id===meeting.type).name || '—' }}</div>
          </el-col>
          <el-col :span="2">
            <div class="info-label">Формат</div>
            <div class="info-value">{{ $oneToOneConstants.meetings.formatSelectOptions.find(e=>e.id===meeting.format).name  || '—' }}</div>
          </el-col>
        </el-row>
        <el-row v-if="meeting.location || meeting.desc" :gutter="24">
        <el-divider></el-divider>
          <el-col :span="12" v-if="meeting.location">
            <div class="info-label">Место / ссылка</div>
            <div class="info-value">{{ meeting.location }}</div>
          </el-col>
          <el-col :span="12" v-if="meeting.desc">
            <div class="info-label">Описание</div>
            <div class="info-value">{{ meeting.desc }}</div>
          </el-col>
        </el-row>
      </el-card>


      <el-card class="meeting-section-card" shadow="never">
        <div slot="header" class="section-card-header">
          <span>Повестка встречи</span>
        </div>
        <agenda-blocks-section :meeting="meeting" />
      </el-card>


      <el-card
        v-if="meeting.status !== 'planned'"
        class="meeting-section-card"
        shadow="never"
      >
        <div slot="header" class="section-card-header">
          <span>Протокол встречи</span>
          <el-tag v-if="protocol && protocol.fixed_at" size="small" type="success">Зафиксирован</el-tag>
        </div>

        <div v-loading="protocolLoading">
          <template v-if="protocol">
            <el-form label-position="top">
              <el-form-item label="Итоги / результаты встречи">
                <el-input
                  v-if="!protocol.fixed_at && $canAndRulesPass(meeting, $permissions.ONE_TO_ONE.PROTOCOL_MANAGE)"
                  v-model="protocol.results"
                  type="textarea"
                  :rows="4"
                  placeholder="Опишите итоги встречи..."
                  @blur="saveProtocol"
                />
                <div v-else style="white-space: pre-wrap">
                  {{protocol.results}}
                </div>
              </el-form-item>
            </el-form>

            <div v-if="!protocol.fixed_at" style="text-align: right; margin-top: 8px;">
              <el-button
                v-if="$canAndRulesPass(meeting, $permissions.ONE_TO_ONE.PROTOCOL_MANAGE)"
                type="primary"
                :loading="fixingProtocol"
                @click="fixProtocol"
              >
                Зафиксировать протокол
              </el-button>
            </div>
          </template>
        </div>
      </el-card>
    </template>

    <meeting-edit-dialog
      ref="editDialog"
      @saved="onMeetingUpdated"
    />
  </div>
</template>

<script>
import PageHeading from "@/components/PageHeading.vue";
import AgendaBlocksSection from "@/modules/oneToOne/components/agendaBlocks/AgendaBlocksSection.vue";
import MeetingEditDialog from "@/modules/oneToOne/components/meetings/MeetingEditDialog.vue";
import {Constants as $oneToOneConstants} from "@/modules/oneToOne/base/oneToOneConstants";

export default {
  name: 'OneToOneMeeting',
  components: { PageHeading, AgendaBlocksSection, MeetingEditDialog },
  computed: {
    meetingId() {
      return parseInt(this.$route.params.id);
    },
    $oneToOneConstants() {
      return $oneToOneConstants
    },
    meetingHeading() {
      if (!this.meeting) return 'Встреча 1:1';
      const type = this.$oneToOneConstants.meetings.typeSelectOptions.find(e=>e.id===this.meeting.type).name || 'Встреча 1:1';
      const date = this.formatDate(this.meeting.date);
      return `${type} — ${date}`;
    },
  },

  data() {
    return {
      loading:        false,
      actionLoading:  false,
      meeting:        null,

      protocolLoading: false,
      protocol:        null,
      fixingProtocol:  false,
    };
  },


  mounted() {
    this.load();
  },

  methods: {
    load() {
      this.loading = true;
      this.$api.oneToOne.meetingView({
        id: this.meetingId,
        expand: [
          'permissions',
          'participant',
          'initiator',
        ].join(),
      })
        .then(data => {
          this.meeting = data.meeting;
          if (this.meeting.status !== 'planned') {
            this.loadProtocol();
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },

    loadProtocol() {
      this.protocolLoading = true;
      this.$api.oneToOne.protocolView({ meeting_id: this.meetingId })
        .then(data => {
          this.protocol = data.protocol;
        })
        .finally(() => {
          this.protocolLoading = false;
        });
    },

    finishMeeting() {
      this.actionLoading = true;
      this.$api.oneToOne.meetingFinish({ id: this.meetingId })
        .then(() => {
          this.load();
        })
        .finally(() => {
          this.actionLoading = false;
        });
    },

    cancelMeeting() {
      this.$api.oneToOne.meetingCancel({ id: this.meetingId })
        .then(() => {
          this.load();
        });
    },

    onMeetingUpdated(updated) {
      Object.assign(this.meeting, updated);
    },

    saveProtocol() {
      if (!this.protocol || this.protocol.fixed_at) {
        return;
      }
      this.$api.oneToOne.protocolUpdate({
        meeting_id: this.meetingId,
        results:    this.protocol.results,
      })
        .then(data => {
          this.$notify.success({
            title: 'Сохранено',
            message: 'Итоги успешно сохранены'
          });
        })
    },

    fixProtocol() {
      this.fixingProtocol = true;
      this.$api.oneToOne.protocolFix({
        meeting_id: this.meetingId,
      })
        .then(data => {
          this.protocol = data.protocol;
          this.meeting.status = $oneToOneConstants.meetings.statuses.STATUS_RESULTS_DONE;
        })
        .finally(() => {
          this.fixingProtocol = false;
        });
    },

    // uploadRecording({ file }) {
    //   const formData = new FormData();
    //   formData.append('meeting_id', this.meetingId);
    //   formData.append('recording', file);
    //   this.$api.oneToOne.protocolUploadRecording(formData)
    //     .then(data => {
    //       if (data.recording_url) this.protocol.recording_url = data.recording_url;
    //     });
    // },

    formatDate(date) {
      if (!date) return '—';
      const [y, m, d] = date.split('-');
      return `${d}.${m}.${y}`;
    },
  },
};
</script>

<style lang="scss" scoped>
.meeting-info-card {
  margin-bottom: 20px;
}

.meeting-section-card {
  margin-bottom: 20px;
}

.section-card-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-weight: 600;
}

.info-label {
  font-size: 12px;
  color: #909399;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.4px;
  margin-bottom: 4px;
}

.info-value {
  font-size: 14px;
  color: #303133;
}
</style>